import styled from 'styled-components';
import { rem } from 'styles/theme';

export const LoadMoreStyled = styled.div`
    margin-top: ${rem(32)};
`;
